module.exports = __webpack_public_path__ + "img/logo-pdf-link.3985b8d7.svg";